export default {
  chartLegend: {
    buyUp: 'Buy up',
    sellDown: 'Sell Down',
    unidentified: 'Unidentified',
  },

  listTitleTable: {
    time: 'THỜI GIAN', // hh:mm
    bidVolume: 'KL MUA',
    bid: 'GIÁ MUA',
    volumeDone: 'KL KHỚP',
    priceDone: 'GIÁ KHỚP',
    type: 'KIỂU',
    ask: 'GIÁ BÁN',
    askVolume: 'KL BÁN',
    totalVolume: 'TỔNG KL KHỚP',
  },
};
